// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UploadDocumentFileRequestModel from '../../model/upload-document-file-request-model';
import UploadDocumentFileRequestDTO from '../dto/upload-document-file-request-dto';
import dtoSchema from '../schemas/upload-document-file-request-schema';

export default abstract class UploadDocumentFileRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UploadDocumentFileRequestDTO>) {
    super();
    if (data) {
      this.uploadFile = data.uploadFile;
    }
  }
  /**
  * @type {binary}
  */
  uploadFile?: File;

  static toModel(dto: DeepPartial<UploadDocumentFileRequestDTO>): UploadDocumentFileRequestModel;
  static toModel(dto: DeepPartial<UploadDocumentFileRequestDTO> | undefined | null): UploadDocumentFileRequestModel | undefined;
  static toModel(dto: DeepPartial<UploadDocumentFileRequestDTO> | undefined | null): UploadDocumentFileRequestModel | undefined {
    return dto ? new UploadDocumentFileRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UploadDocumentFileRequestModel> | UploadDocumentFileRequestModel): UploadDocumentFileRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      uploadFile: unwrapped.uploadFile,
    } as UploadDocumentFileRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UploadDocumentFileRequestModel, can not map to UploadDocumentFileRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
